import React from 'react';
import PropTypes from 'prop-types';

import Badge from 'components/Badge';

InventoryCenterBadges.propTypes = {
    shipments: PropTypes.arrayOf(PropTypes.shape({
        inventory: PropTypes.shape({
            inventoryCenterName: PropTypes.string,
        }),
    })),
    style: PropTypes.object,
};

export default function InventoryCenterBadges({shipments, style}) {
    if (!Array.isArray(shipments)) {
        return null;
    }

    // We only keep unique value for new Set()
    const centers = [...new Set(shipments.map(s => s.inventory?.inventoryCenterName).filter(name => name !== undefined))];

    if (centers.length === 0) {
        return null;
    }

    return (
        <div style={{display: 'flex', gap: '4px', flexWrap: 'wrap', ...style}}>
            {centers.map((center) => (
                <Badge
                    key={center}
                    label={center}
                    color="default"
                    rounded
                    size="small"
                />
            ))}
        </div>
    );
}
